import React, { SVGProps } from 'react'

const Sparkle: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none" role="img" {...props}>
    <path
      d="M10 4C10 4 10.3463 6.57731 11.3505 7.64955C12.429 8.80116 15 9 15 9C15 9 12.429 9.19884 11.3505 10.3505C10.3463 11.4227 10 14 10 14C10 14 9.65372 11.4227 8.64955 10.3505C7.57104 9.19884 5 9 5 9C5 9 7.57104 8.80116 8.64955 7.64955C9.65372 6.57731 10 4 10 4Z"
      fill="black"
      fillOpacity="0.45"
    />
    <path
      d="M5 0C5 0 5.27702 2.06184 6.08036 2.91964C6.94317 3.84093 9 4 9 4C9 4 6.94317 4.15907 6.08036 5.08036C5.27702 5.93816 5 8 5 8C5 8 4.72298 5.93816 3.91964 5.08036C3.05683 4.15907 1 4 1 4C1 4 3.05683 3.84093 3.91964 2.91964C4.72298 2.06184 5 0 5 0Z"
      fill="black"
      fillOpacity="0.45"
    />
    <path
      d="M3 7C3 7 3.20777 8.54638 3.81027 9.18973C4.45738 9.88069 6 10 6 10C6 10 4.45738 10.1193 3.81027 10.8103C3.20777 11.4536 3 13 3 13C3 13 2.79223 11.4536 2.18973 10.8103C1.54262 10.1193 0 10 0 10C0 10 1.54262 9.88069 2.18973 9.18973C2.79223 8.54638 3 7 3 7Z"
      fill="black"
      fillOpacity="0.45"
    />
  </svg>
)

export default Sparkle
